import moment from 'moment'

import { API_DATE_FORMAT } from 'lib/participants/Constants'

type MappedFiltersState = {
  [key: string]: any
}

export const getMappedFilters = (state: MappedFiltersState) => {
  const fieldName = 'last_visited'
  const hasValidBeforeDate = moment(state.lastSeenBefore).isValid()
  const hasValidAfterDate = moment(state.lastSeenAfter).isValid()

  const formattedBeforeDate = moment(state.lastSeenBefore).format(
    API_DATE_FORMAT,
  )

  const formattedAfterDate = moment(state.lastSeenAfter).format(API_DATE_FORMAT)

  const mappedFilters = [
    {
      fieldName,
      condition: 'before',
      value: hasValidBeforeDate ? formattedBeforeDate : null,
      UIValue: hasValidBeforeDate ? state.lastSeenBefore : null,
      type: 'lastSeenBefore',
      component: hasValidBeforeDate ? 'FilterByLastSeen' : '',
    },
    {
      fieldName,
      condition: 'after',
      value: hasValidAfterDate ? formattedAfterDate : null,
      UIValue: hasValidAfterDate ? state.lastSeenAfter : null,
      type: 'lastSeenAfter',
      component: hasValidAfterDate ? 'FilterByLastSeen' : '',
    },
    {
      fieldName,
      condition: 'more_than',
      value: state.lastSeenMoreThan,
      type: 'lastSeenMoreThan',
      component: state.lastSeenMoreThan && 'FilterByLastSeen',
    },
    {
      fieldName,
      condition: 'less_than',
      value: state.lastSeenLessThan,
      type: 'lastSeenLessThan',
      component: state.lastSeenLessThan && 'FilterByLastSeen',
    },
  ]

  return mappedFilters
}
